<p>
  Auth! {{accountService.getUserLogin()}}
  <button routerLink="/login" *ngIf="showLoginButton">Log in</button>
  <button (click)="logout()" *ngIf="showLogoutButton">Log out</button>
</p>
